import gql from 'graphql-tag';

export const getResidentProfile = gql(`
query getResidentProfile($personId: UUID!, $propertyId: UUID!) {
    resident(personId: $personId, propertyId: $propertyId) {
        id
        status
        unitIds
        moveInDate
        moveOutDate
    }
}
`);
